<form novalidate [formGroup]="form" (ngSubmit)="save()">
    <div class="card h-100">
        <div class="card-header">
            <h6>Panel Informativo Dependencia</h6>
        </div>
        <app-editor-html [form]="form"  style="min-height: 500px;" />
        <div class="card-footer">
            <button class="btn  btn-primary">GUARDAR CAMBIOS</button>
        </div>
    </div>
</form>